import {
  BatchTohanMarcRegConditionListItem,
  BatchTohanMarcRegConditionListItemFromJSON
} from '@/api/models/batch/BatchTohanMarcRegConditionListItem'

export interface BatchTohanMarcRegPageLoadResult {
  items: BatchTohanMarcRegConditionListItem
}

export function BatchTohanMarcRegPageLoadResultFromJSON(
  json: any
): BatchTohanMarcRegPageLoadResult {
  return {
    items: BatchTohanMarcRegConditionListItemFromJSON(json)
  }
}
